var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable max-lines */
import { DrawerBody } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { DateTime } from 'luxon';
import React, { useEffect, useState, } from 'react';
import { getQuantityByStatus } from '../../../utils/order-details/LineItemUtils';
import { SubmitDeliveryAddressGetCitiesByZipCode } from '../../../api/oms/edit-delivery-address';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { OmmAvailableDeliverySlots, OmmAvailableFulfillmentOptions, } from '../../../hooks/delivery-hooks';
import { useExperienceContext, useOrderContext, useFulfillmentGroupContext, useEditDeliveryAddressContext, } from '../../../hooks/useContexts';
import { EditDeliveryAddressErrorMessages, } from '../../../models/edit-delivery-address';
import '../../../styles/drawer.scss';
import { getAddresses, submitEditDeliveryAddress, validateDeliveryAddress, getInitialZipCode, getIsZipCodeEligibilityEnabled, handleEligibility, } from '../../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { getWindow } from '../../../utils/general';
import { areAddressesEqual, extractAddressFromFulfillmentGroup, } from '../../../utils/order-details/OrderDetailsUtils';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { getFlowTypeValue } from '../util/OutOfStock';
import { EditDeliveryAddressChangeFormBody } from './EditDeliveryAddressChangeFormBody';
import { EditDeliveryAddressChangeFormFooter } from './EditDeliveryAddressChangeFormFooter';
import { EditDeliveryAddressChooseAddress } from './EditDeliveryAddressChooseAddress';
export var EditDeliveryAddressChangeForm = function (_a) {
    var _b, _c, _d;
    var closeDrawer = _a.closeDrawer, setIsChangeForm = _a.setIsChangeForm, setShowDrawerError = _a.setShowDrawerError, setIsDeliveryDetails = _a.setIsDeliveryDetails, setUpdatedAddressData = _a.setUpdatedAddressData, setNewDeliveryAddressDetails = _a.setNewDeliveryAddressDetails, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, previousCountry = _a.previousCountry, setIsAddressList = _a.setIsAddressList, isAddressList = _a.isAddressList, isDefaultValue = _a.isDefaultValue, setIsDefault = _a.setIsDefault, isLoading = _a.isLoading, setIsLoading = _a.setIsLoading, isExcludedAddress = _a.isExcludedAddress, setIsExcludedAddress = _a.setIsExcludedAddress, isValidated = _a.isValidated, setIsValidated = _a.setIsValidated, deliveryAddressCreateCartRequestData = _a.deliveryAddressCreateCartRequestData, submitCreateForm = _a.submitCreateForm, setSubmitCreateForm = _a.setSubmitCreateForm, validationEt = _a.validationEt, setValidationEt = _a.setValidationEt, setIsDeliveryOptions = _a.setIsDeliveryOptions;
    var _e = useFulfillmentGroupContext(), fulfillmentGroup = _e.fulfillmentGroup, fulfillmentGroupIndex = _e.fulfillmentGroupIndex;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var orderDetailsData = useOrderContext().orderDetailsData;
    var _f = useEditDeliveryAddressContext(), _g = _f.formState, firstNameValue = _g.firstNameValue, lastNameValue = _g.lastNameValue, streetAddressValue = _g.streetAddressValue, addressLineTwoValue = _g.addressLineTwoValue, zipCodeValue = _g.zipCodeValue, cityStateValue = _g.cityStateValue, phoneNumberValue = _g.phoneNumberValue, updateFormField = _f.updateFormField, setAvailableDeliverySlots = _f.setAvailableDeliverySlots, setSelectedDateId = _f.setSelectedDateId, setAvailableDeliverySlotsResponse = _f.setAvailableDeliverySlotsResponse, setDeliveryAddresses = _f.setDeliveryAddresses, setSelectedAddressId = _f.setSelectedAddressId, isEligibilityChecked = _f.isEligibilityChecked, isEligible = _f.isEligible, setIsEligible = _f.setIsEligible, setIsEligibilityChecked = _f.setIsEligibilityChecked;
    var _h = useOrderContext(), setFulfillmentOptionsResponse = _h.setFulfillmentOptionsResponse, setExcludedShipStateApiError = _h.setExcludedShipStateApiError, setDeliveryAddressesApiError = _h.setDeliveryAddressesApiError, setDeliveryAvailableSlotsApiError = _h.setDeliveryAvailableSlotsApiError, currentBopisOosDrawer = _h.currentBopisOosDrawer;
    var _j = useState(false), invalidField = _j[0], setInvalidField = _j[1];
    var _k = useState(previousCountry), country = _k[0], setCountry = _k[1];
    var _l = useState(false), isPOBoxAddressLine1 = _l[0], setIsPOBoxAddressLine1 = _l[1];
    var _m = useState(false), isPOBoxAddressLine2 = _m[0], setIsPOBoxAddressLine2 = _m[1];
    var _o = useState(false), isZipCodeChanged = _o[0], setIsZipCodeChanged = _o[1];
    var _p = useState([]), getCitiesByZipCode = _p[0], setGetCitiesByZipCode = _p[1];
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var traceId = orderDetailsData.traceId;
    var flowType = getFlowTypeValue(currentBopisOosDrawer, FLOW_TYPES.EDIT_DELIVERY_ADDRESS);
    var _q = useState(false), isSameAddress = _q[0], setIsSameAddress = _q[1];
    var _r = useThdCustomer() || {}, isLoggedIn = _r.isLoggedIn, isExchangeCustomer = _r.isExchangeCustomer;
    var _s = useState([]), localCities = _s[0], setLocalCities = _s[1];
    var _t = useState(false), enteredEditFlow = _t[0], setEnteredEditFlow = _t[1];
    var isAuthTHDUser = Boolean(isLoggedIn && !isExchangeCustomer);
    var isAddingNewAddress = Boolean(FeatureSwitches.enableEditDeliveryAddressAppify) && !isAddressList;
    var fulfillmentTypeCode = ((_c = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || undefined;
    var isZipCodeEligibilityEnabled = getIsZipCodeEligibilityEnabled(fulfillmentGroup);
    var _u = useState(false), isSkeletonLoading = _u[0], setIsSkeletonLoading = _u[1];
    // When switching back to the address list view, clear selection so the first tile is auto-selected
    useEffect(function () {
        if (isAddressList) {
            setSelectedAddressId('');
        }
    }, [isAddressList]);
    var handleZipCodeStatus = function () {
        if ((invalidField && zipCodeValue.length !== 5) || isExcludedAddress) {
            return 'error';
        }
        if (!isValidated) {
            return 'warning';
        }
        if (isSameAddress) {
            return 'error';
        }
        if (isEligibilityChecked && !isEligible) {
            return 'error';
        }
        return undefined;
    };
    var _v = extractAddressFromFulfillmentGroup(fulfillmentGroup.shippingAndHandling ||
        fulfillmentGroup.storePickup ||
        fulfillmentGroup.bodfsDeliveryAndHandling, fulfillmentGroup.fulfillmentType), firstName = _v.firstName, lastName = _v.lastName, addressLine1 = _v.addressLine1, addressLine2 = _v.addressLine2, zipCode = _v.zipCode, city = _v.city, state = _v.state, phoneNumber = _v.phoneNumber;
    useEffect(function () {
        if (!submitCreateForm)
            return;
        // Address has been validated
        // Render Delivery Options when FS is true, not for BOPIS OOS
        if (FeatureSwitches.isSFBLEnabled && !currentBopisOosDrawer) {
            setIsChangeForm(false);
            setIsDeliveryOptions(true);
            setIsLoading(false);
        }
        else {
            if (fulfillmentGroup.fulfillmentType === FULFILLMENT_TYPE.BODFS) {
                getAvailableSlots();
            }
            else {
                submitEditDeliveryAddress({
                    deliveryAddress: deliveryAddress,
                    firstNameValue: firstNameValue,
                    lastNameValue: lastNameValue,
                    phoneNumberValue: phoneNumberValue,
                    isDefaultValue: isDefaultValue,
                    orderDetailsData: orderDetailsData,
                    fulfillmentTypeCode: fulfillmentTypeCode,
                    deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData,
                    isAddingNewAddress: isAddingNewAddress,
                    fulfillmentGroupIndex: fulfillmentGroupIndex,
                    fulfillmentGroup: fulfillmentGroup,
                    traceId: traceId,
                    setIsChangeForm: setIsChangeForm,
                    setIsDeliveryDetails: setIsDeliveryDetails,
                    setIsLoading: setIsLoading,
                    setShowDrawerError: setShowDrawerError,
                    setExcludedShipStateApiError: setExcludedShipStateApiError,
                    setIsExcludedAddress: setIsExcludedAddress,
                    setIsValidated: setIsValidated,
                    closeDrawer: closeDrawer,
                    setUpdatedAddressData: setUpdatedAddressData,
                    setEditDeliveryAddressAlert: setEditDeliveryAddressAlert,
                    flowType: flowType,
                });
            }
            // reset submitCreateForm to false
            setSubmitCreateForm(false);
        }
    }, [submitCreateForm]);
    useEffect(function () {
        var _a, _b;
        if (getCitiesByZipCode.length > 0 && isZipCodeChanged) {
            updateFormField({
                cityStateValue: "".concat((_a = getCitiesByZipCode[0]) === null || _a === void 0 ? void 0 : _a.city, ", ").concat((_b = getCitiesByZipCode[0]) === null || _b === void 0 ? void 0 : _b.stateCode),
            });
            setIsZipCodeChanged(false);
        }
    }, [getCitiesByZipCode]);
    useEffect(function () {
        setIsExcludedAddress(false);
    }, [streetAddressValue, zipCodeValue, addressLineTwoValue, cityStateValue]);
    var deliveryAddress = {
        addressLine1: streetAddressValue || '',
        addressLine2: addressLineTwoValue || null,
        city: cityStateValue.split(',')[0],
        state: (_d = cityStateValue === null || cityStateValue === void 0 ? void 0 : cityStateValue.split(',')[1]) === null || _d === void 0 ? void 0 : _d.trim(),
        zipCode: zipCodeValue,
        country: country,
    };
    var getAvailableSlots = function () {
        var _a, _b, _c;
        var availableSlotsRequest = {
            flowType: FLOW_TYPES.EDIT_DELIVERY_ADDRESS,
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
            fulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
            originalFulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '',
            newFulfillmentType: null,
            deliverySlotTypes: ['All Day'],
            et: fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.et,
            net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
            lineItems: ((_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _c === void 0 ? void 0 : _c.map(function (type) { return ({
                lineId: type.lineId,
                omsId: "".concat(type.secOmsId),
                sku: "".concat(type.skuNumber),
                price: type.unitPrice,
                quantity: type.currentQuantity,
            }); })) || [],
            fulfillmentAddress: deliveryAddress,
        };
        OmmAvailableDeliverySlots(availableSlotsRequest, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
            .then(function (response) {
            var _a, _b;
            var data = response.data.data;
            setAvailableDeliverySlotsResponse(data);
            var sortedSlots = __spreadArray([], ((_a = data === null || data === void 0 ? void 0 : data.availableDeliverySlots) !== null && _a !== void 0 ? _a : []), true).sort(function (slotA, slotB) {
                return DateTime.fromISO(slotA.startDateTime).toMillis() -
                    DateTime.fromISO(slotB.startDateTime).toMillis();
            });
            setDeliveryAvailableSlotsApiError(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
            });
            if (sortedSlots.length > 0) {
                setSelectedDateId(((_b = sortedSlots === null || sortedSlots === void 0 ? void 0 : sortedSlots[0]) === null || _b === void 0 ? void 0 : _b.id) || '');
                setAvailableDeliverySlots(sortedSlots);
                setIsChangeForm(false);
                setIsDeliveryDetails(true);
            }
            else {
                setIsExcludedAddress(true);
            }
        })
            .catch(function () {
            setDeliveryAvailableSlotsApiError(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
            });
            closeDrawer();
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var handleClearAll = function () {
        updateFormField({
            firstNameValue: '',
            lastNameValue: '',
            streetAddressValue: '',
            addressLineTwoValue: null,
            zipCodeValue: '',
            cityStateValue: '',
        });
        setCountry(previousCountry);
        setIsSameAddress(false);
        setIsDefault(false);
    };
    var checkSameAddress = function () {
        return areAddressesEqual({
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            city: city,
            state: state,
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            zipCode: zipCode,
            country: country,
        }, __assign({ firstName: firstNameValue, lastName: lastNameValue, phoneNumber: phoneNumberValue }, deliveryAddress));
    };
    var handleValidateDeliveryAddress = function () {
        validateDeliveryAddress({
            firstNameValue: firstNameValue,
            lastNameValue: lastNameValue,
            phoneNumberValue: phoneNumberValue,
            streetAddressValue: streetAddressValue,
            addressLineTwoValue: addressLineTwoValue,
            zipCodeValue: zipCodeValue,
            cityStateValue: cityStateValue,
            country: country,
            flowType: flowType,
            fulfillmentTypeCode: fulfillmentTypeCode,
            orderDetailsData: orderDetailsData,
            setInvalidField: setInvalidField,
            setIsSameAddress: setIsSameAddress,
            setIsLoading: setIsLoading,
            setNewDeliveryAddressDetails: setNewDeliveryAddressDetails,
            setShowDrawerError: setShowDrawerError,
            fulfillmentGroupIndex: fulfillmentGroupIndex,
            setIsValidated: setIsValidated,
            closeDrawer: closeDrawer,
            setValidationEt: setValidationEt,
            validationEt: validationEt,
            traceId: traceId,
            deliveryAddress: deliveryAddress,
            checkSameAddress: checkSameAddress,
            isPOBoxAddressLine1: isPOBoxAddressLine1,
            isPOBoxAddressLine2: isPOBoxAddressLine2,
            setSubmitCreateForm: setSubmitCreateForm,
            EditDeliveryAddressErrorMessages: EditDeliveryAddressErrorMessages,
            isValidated: isValidated,
            isAddressList: isAddressList,
        });
    };
    var handleChange = function (event) {
        updateFormField({
            cityStateValue: event.target.value,
        });
    };
    var handleZipCodeValueChange = function (zipCodeChange) {
        var _a, _b, _c, _d;
        var request = {
            zipCode: zipCodeChange || zipCode,
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            flowType: flowType,
            fulfillmentType: fulfillmentTypeCode,
            originalFulfillmentType: fulfillmentTypeCode,
            newFulfillmentType: null,
        };
        setGetCitiesByZipCode([]);
        var availableFulfillmentOptions = {
            flowType: flowType,
            orderId: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber) || '',
            emailId: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId) || '',
            originalFulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
            newFulfillmentType: null,
            storeNumber: (_b = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber) === null || _b === void 0 ? void 0 : _b.toString(),
            lineItems: ((_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _c === void 0 ? void 0 : _c.filter(function (type) {
                return type.lineId !== undefined && type.currentQuantity !== undefined;
            })) === null || _d === void 0 ? void 0 : _d.map(function (type) { return ({
                lineId: type.lineId,
                omsId: "".concat(type.secOmsId),
                sku: "".concat(type.skuNumber),
                quantity: getQuantityByStatus(type),
            }); })) || [],
            fulfillmentAddress: {
                zipCode: request.zipCode,
            },
            net: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net) || '',
        };
        if (isZipCodeEligibilityEnabled && isAddressList) {
            setIsSkeletonLoading(true);
            return OmmAvailableFulfillmentOptions(availableFulfillmentOptions, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
                .then(function (response) {
                setFulfillmentOptionsResponse(response.data);
                handleEligibility(response.data, availableFulfillmentOptions, fulfillmentGroup, updateFormField, setIsEligible);
                setIsEligibilityChecked(true);
            })
                .catch(function () {
                setShowDrawerError(fulfillmentGroupIndex);
                closeDrawer();
            })
                .finally(function () {
                setIsSkeletonLoading(false);
            });
        }
        return SubmitDeliveryAddressGetCitiesByZipCode(request, setGetCitiesByZipCode, setIsChangeForm, setShowDrawerError, fulfillmentGroupIndex, isAuthTHDUser, fulfillmentGroup, orderDetailsData, setIsEligible, updateFormField, setIsEligibilityChecked, setIsSkeletonLoading, availableFulfillmentOptions, setFulfillmentOptionsResponse, closeDrawer);
    };
    useEffect(function () {
        if (!currentBopisOosDrawer &&
            !enteredEditFlow &&
            !isZipCodeEligibilityEnabled) {
            handleZipCodeValueChange();
        }
        setEnteredEditFlow(true);
        if (isAddressList) {
            setIsSkeletonLoading(true);
            // Reset eligibility check state when opening drawer
            setIsEligibilityChecked(false);
            getAddresses({
                orderDetailsData: orderDetailsData,
                fulfillmentTypeCode: fulfillmentTypeCode,
                isAuthTHDUser: isAuthTHDUser,
                fulfillmentGroup: fulfillmentGroup,
                fulfillmentGroupIndex: fulfillmentGroupIndex,
                setDeliveryAddresses: setDeliveryAddresses,
                setDeliveryAddressesApiError: setDeliveryAddressesApiError,
                closeDrawer: closeDrawer,
            })
                .then(function () {
                var initialZipCode = getInitialZipCode(fulfillmentGroup, fulfillmentGroup.fulfillmentType);
                if (isZipCodeEligibilityEnabled && (initialZipCode === null || initialZipCode === void 0 ? void 0 : initialZipCode.length) === 5) {
                    if (zipCodeValue && zipCodeValue !== initialZipCode) {
                        return handleZipCodeValueChange(zipCodeValue);
                    }
                    return handleZipCodeValueChange(initialZipCode);
                }
                return null;
            })
                .finally(function () {
                setIsSkeletonLoading(false);
            });
        }
    }, [isAddressList]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null, isAddressList ? (React.createElement(EditDeliveryAddressChooseAddress, { setCountry: setCountry, handleClearAll: handleClearAll, setIsAddressList: setIsAddressList, setIsDefault: setIsDefault, isExcludedAddress: isExcludedAddress, isSameAddress: isSameAddress, setIsSameAddress: setIsSameAddress, setLocalCities: setLocalCities, setIsValidated: setIsValidated, setInvalidField: setInvalidField, setIsZipCodeChanged: setIsZipCodeChanged, handleZipCodeValueChange: handleZipCodeValueChange, handleZipCodeStatus: handleZipCodeStatus, invalidField: invalidField, isSkeletonLoading: isSkeletonLoading })) : (React.createElement(EditDeliveryAddressChangeFormBody, { getCitiesByZipCode: getCitiesByZipCode, invalidField: invalidField, isExcludedAddress: isExcludedAddress, isValidated: isValidated, setIsValidated: setIsValidated, isPOBoxAddressLine1: isPOBoxAddressLine1, setIsPOBoxAddressLine1: setIsPOBoxAddressLine1, isPOBoxAddressLine2: isPOBoxAddressLine2, setIsPOBoxAddressLine2: setIsPOBoxAddressLine2, setIsZipCodeChanged: setIsZipCodeChanged, handleZipCodeValueChange: handleZipCodeValueChange, handleChange: handleChange, isSameAddress: isSameAddress, setIsSameAddress: setIsSameAddress, handleClearAll: handleClearAll, setLocalCities: setLocalCities, localCities: localCities, handleZipCodeStatus: handleZipCodeStatus }))),
        React.createElement(EditDeliveryAddressChangeFormFooter, { isLoading: isLoading, isValidated: isValidated, isIosMobile: isIosMobile, handleValidateDeliveryAddress: handleValidateDeliveryAddress, closeDrawer: closeDrawer, isAddressList: isAddressList, isSkeletonLoading: isSkeletonLoading })));
};
